export default __webpack_public_path__ + "static/media/icons8-cloud-firestore.d80714d2.svg";